import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, gbp } from "@/lib/api";
import { AdminTitle } from "./AdminLayout";
import { SalesSummary } from "./SalesSummary";

const CARDS = [
  ["in_stock", "Vehicles in stock"], ["stock_value", "Total stock value", gbp], ["average_price", "Average vehicle price", gbp],
  ["reserved", "Vehicles reserved"], ["sold_this_month", "Sold this month"], ["new_enquiries", "New enquiries", null, "/admin/enquiries"],
  ["valuation_requests", "Valuation requests", null, "/admin/valuations"], ["pending_reservations", "Pending reservations", null, "/admin/reservations"],
];

export default function AdminDashboard() {
  const [m, setM] = useState(null);
  const [recent, setRecent] = useState([]);
  useEffect(() => {
    api.get("/admin/metrics").then((r) => setM(r.data)).catch(() => {});
    api.get("/admin/enquiries").then((r) => setRecent((r.data || []).slice(0, 6))).catch(() => {});
  }, []);
  return (
    <div data-testid="admin-dashboard">
      <AdminTitle title="Dashboard"><Link to="/admin/vehicles/new" className="btn btn-primary !py-3" data-testid="dash-add-vehicle">Add vehicle</Link></AdminTitle>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {CARDS.map(([k, label, fmt, to]) => {
          const body = (
            <div className="h-full border border-stone bg-paper p-5" data-testid={`metric-${k}`}>
              <p className="text-xs uppercase tracking-[0.14em] text-charcoal/70">{label}</p>
              <p className="mt-3 font-serif text-4xl text-forest">{m ? (fmt ? fmt(m[k]) : m[k]) : "—"}</p>
            </div>
          );
          return to ? <Link key={k} to={to}>{body}</Link> : <div key={k}>{body}</div>;
        })}
      </div>
      <SalesSummary />
      <h2 className="mb-4 mt-12 font-serif text-2xl">Latest enquiries</h2>
      <div className="overflow-x-auto border border-stone bg-paper">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-stone text-xs uppercase tracking-[0.12em] text-charcoal/70"><tr><th className="p-3">Date</th><th className="p-3">Name</th><th className="p-3">Type</th><th className="p-3">Vehicle</th><th className="p-3">Status</th></tr></thead>
          <tbody>
            {recent.length === 0 && <tr><td className="p-4 text-charcoal/70" colSpan={5}>No enquiries yet.</td></tr>}
            {recent.map((e) => (
              <tr key={e.id} className="border-b border-stone/60"><td className="p-3">{new Date(e.created_at).toLocaleDateString("en-GB")}</td><td className="p-3">{e.name}</td><td className="p-3">{e.enquiry_type}</td><td className="p-3">{e.vehicle_title || "—"}</td><td className="p-3">{e.status}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
